import React from 'react';
import { ImageFile } from '~/data/types/images';

const CarPromotionDoodleStar: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="34"
      fill="none"
      viewBox="0 0 33 34"
    >
      <path
        stroke="#FFE500"
        strokeLinecap="round"
        strokeWidth="3.652"
        d="M19.053 2.158c-.898 4.177-5.432 12.53-16.386 12.53M19.053 31.555c.636-4.123 3.85-12.369 11.613-12.369"
      ></path>
      <path
        stroke="#FFE500"
        strokeLinecap="round"
        strokeWidth="3.652"
        d="M19.053 2c.636 5.73 3.85 17.187 11.613 17.187M19.053 31.555c-.898-5.622-5.432-16.866-16.386-16.866"
      ></path>
    </Component>
  );
};

export default CarPromotionDoodleStar;
